module.exports = __webpack_public_path__ + "img/pin-in-1.0c7e0d22.svg";